import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import { toast } from 'react-toastify';
import arrow from "../assets/images/arrow.png";
import { getChildren } from '../services/ProfileApi';
import { getDashboardData } from '../services/dashboardApi';
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';
import ChildDefault from '../assets/images/default.png'
import ProgramSlider from "../pages/ProgramSlider"
import { showToast } from '../config/Alert';
import copyIcon from "../assets/images/copy-paste.png";

const Dashboard = () => {
  const [children, setChildren] = useState([]);
  const [slides, setSlides] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [offers, setOffers] = useState([]);
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchDashboardData = useCallback(async () => {
    try {
      const dashboardData = await getDashboardData();
      setSlides(dashboardData.data.slides || []);
      setWorkshops(dashboardData.data.workshops || []);
      setOffers(dashboardData.data.offers || []);
      setNotices(dashboardData.data.notices || []);
      const childrenResponse = await getChildren(user.id);
      setChildren(childrenResponse.data || []);
    } catch (error) {
      toast.error("Failed to fetch dashboard data");
    } finally {
      setLoading(false);
    }
  }, [user.id]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  if (loading) {
    return <LoadingSpinner />;
  }

  var bannerSettings = {
    dots: true,
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false
  };

  var childview = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2, initialSlide: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
  };

  return (
    <div className='app-container mobile-bottom'>
      <Container>

        <h2 className='fs-20 fw-6'>
          <span className='small-hello fs-14'>Hello, </span>
          <span className='bigg-name'>{user?.name}!</span>
        </h2>
        <Slider className='single-items' {...bannerSettings}>
          {slides.map(slide => (
            <div key={slide.id} className='main-banner position-relative'>
              <div className='banner-title text-center'>
                <h2 className='fs-18 fw-6'>{slide.slider_title}</h2>
                <p className='fs-12'>{slide.slider_caption}</p>
              </div>
              <img
                src={`${config.Image_Base_URL}${slide.slide_image}`}
                alt="Logo"
                className="slider-image rounded-3 border border-2 border-secondary" />
            </div>
          ))}
        </Slider>

        <h2 className='mt-4 fs-20 fw-6'>Get Started</h2>
        <Row className='mb-3 steps-card'>
          <Col xs lg='4'>
            <Card className='mb-3'>
              <Link to='/learn_about_us' className='text-decoration-none'>
                <Card.Body className='p-2'>
                  <Card.Title className='text-info fs-16'>Step 1</Card.Title>
                  <Card.Title className='text-danger fs-16'>Learn About Us</Card.Title>
                  <Card.Text className='mb-0 fs-10 text-dark'>Discover who we are and what we offer to inspire your child's journey.</Card.Text>
                  <div className='text-end bottom_arrow'>
                    <img src={arrow} width={12} alt="link" />
                  </div>
                </Card.Body>
              </Link>
            </Card>
          </Col>
          <Col xs lg='4'>
            <Card className='mb-3'>
              <Link to='/explore' className='text-decoration-none'>
                <Card.Body className='p-2'>
                  <Card.Title className='text-info fs-16'>Step 2</Card.Title>
                  <Card.Title className='text-danger fs-16'>Explore the Options</Card.Title>
                  <Card.Text className='mb-0 fs-10 text-dark'>Pick a program your child will love—from art to music & more..</Card.Text>
                  <div className='text-end bottom_arrow'>
                    <img src={arrow} width={12} alt="link" />
                  </div>
                </Card.Body>
              </Link>
            </Card>
          </Col>
          <Col xs lg='4'>
            <Card className='mb-3'>
              <Link to='/joinTheFun' className='text-decoration-none'>
                <Card.Body className='p-2'>
                  <Card.Title className='text-info fs-16'>Step 3</Card.Title>
                  <Card.Title className='text-danger fs-16'>Join the Fun</Card.Title>
                  <p className='mb-0 fs-10 text-dark'>Commit to the programs that spark joy and watch your child thrive</p>
                  <div className='text-end bottom_arrow'>
                    <img src={arrow} width={12} alt="link" />
                  </div>
                </Card.Body>
              </Link>
            </Card>
          </Col>
        </Row>

        <div className='program-we-offer'>
          <div className='mt-4 d-flex justify-content-between align-items-center'>
            <div>
              <h2 className='fs-20 fw-6 mb-1'>Programs We Offer</h2>
              <p className='fs-10 mb-1'>for ages 6-16</p>
            </div>
            <div>
              <Link to='/programs' className='text-info text-decoration-none fs-10'>Know More</Link>
            </div>
          </div>
          <ProgramSlider />
          {/* <Slider className='single-items' {...programsview}>
            {programs.map((program, index) => (
              <div className='imag-title position-relative' key={program.id || index}>
                <Link to={`/course/${program.id}`}>
                  <h3>{program.program_name}</h3>
                  <img src={`${config.Image_Base_URL}${program.program_image}`} className="w-100 pro_image" alt={program.program_name} />
                  <div className='arrow_link'><img src={arrow} alt="link" width={14} /></div>
                </Link>
              </div>
            ))}
          </Slider> */}
        </div>


        {/* <h2 className='mt-5 fs-20 fw-6'></h2> */}
        <div className="mt-5">
          <div className='program-we-offer'>
            <div className='mt-4 d-flex justify-content-between align-items-center'>
              <div>
                <h2 className='fs-20 fw-6 mb-2'>Children's Overview</h2>
              </div>
              <div>
                <Link to='/childProfile' className='text-info text-decoration-none fs-10'>Add new child</Link>
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <Slider className='single-items' {...childview}>
              {children.length > 0 ? (
                children.map((child) => (
                  <div key={child.id}>
                    <Card className='mb-3 child-overview'>
                      <Card.Body>
                        <div className='tag_name d-flex mb-2 justify-content-between align-items-center'>
                          <h1 className='text-white fs-18 mb-0'>{child.child_name}</h1>
                          <img
                            src={child.profile_pic_url ? `${config.Image_Base_URL}${child.profile_pic_url || child}` : ChildDefault}
                            width={35}
                            height={35}
                            alt={child.child_name}
                          />
                        </div>
                        <Card.Subtitle className='text-white fs-11 d-flex align-items-center'>
                          Member Id: <strong> {child.code}</strong>
                          <img
                            className="ms-2"
                            src={copyIcon}
                            alt="Copy"
                            width={14}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              navigator.clipboard.writeText(child.code);
                              showToast("Copied to clipboard", "success");
                            }}
                          />
                        </Card.Subtitle>
                        <Card.Subtitle className='my-2 text-white fs-10'>
                          Subscription: <strong>{child.facility_subscription && child.facility_subscription.length > 0 && child.facility_subscription[0].status === "active" ? 'Active' : 'Deactive'}</strong>
                        </Card.Subtitle>
                        <div className=''>
                          <Button variant="info" className='text-white fs-12 fw-6 rounded-0 border-black' onClick={() => navigate(`/progressReport/${child.id}`)}>View Performance</Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))
              ) : (
                <Card className='mb-3 child-overview'>
                  <Card.Body onClick={() => navigate(`/childProfile`)}>
                    <div className='tag_name d-flex mb-2 justify-content-between align-items-center'>
                      <h1 className='text-white fs-18 mb-0'>Add Child To Continue</h1>
                      <img
                        src={ChildDefault}
                        width={35}
                        height={35}
                        alt='addchild'
                      />
                    </div>
                    <Card.Subtitle className='my-2 text-white fs-12 fw-n'>
                      Add your child and purchase a subscription plan to continue accessing the facility.
                    </Card.Subtitle>
                    <div className=''>
                      <Button variant="info" className='text-white fs-12 fw-6 rounded-2'>Add Child</Button>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </Slider>
          </div>
        </div>


        {/* WORKSHOPS SECTION */}
        {workshops.length > 0 && (
          <div className='workshop-offer'>
            <div className='mt-4 mb-2 d-flex justify-content-between align-items-center'>
              <div>
                <h2 className='fs-20 fw-6 mb-0'>Workshop Sundays</h2>
              </div>
              <div>
                <Link to='https://thepiedpiper.co.in/workshops/' target="_blank" className='text-info text-decoration-none fs-10'>View All</Link>
              </div>
            </div>
            <Row className='mb-3'>
              {workshops.slice(0, 2).map(workshop => (
                <Col xs='6' key={workshop.id}>
                  <div className='border-black border p-3 rounded'>
                    <img src={`${config.Image_Base_URL}${workshop.image}`} className='w-100 workshop_img' alt={workshop.workshop_name} />
                    <h4 className='fw-6 fs-16 mt-1'>{workshop.workshop_name}</h4>
                    <h6 className='fs-8'>{workshop.date} | {workshop.time}</h6>
                    <a href={/^https?:\/\//.test(workshop.link) ? workshop.link : `https://${workshop.link}`} className="btn btn-info text-white btn-sm mt-2" target="_blank" rel="noopener noreferrer">
                      Join Workshop
                    </a>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}

        {/* OFFERS SECTION */}
        {offers.length > 0 && (
          <div className='membership-offer'>
            <h2 className='mt-4 fs-20 fw-6'>Membership Offers</h2>
            <Row className='mb-3'>
              {offers.map(offer => (
                <Col xs='6' key={offer.id}>
                  <a href={/^https?:\/\//.test(offer.link) ? offer.link : `https://${offer.link}`} target="_blank" rel="noopener noreferrer">
                    <div className='border-black border rounded p-2'>
                      <img src={`${config.Image_Base_URL}${offer.image}`} className='w-100 rounded-2' alt="Offer" />
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </div>
        )}

        {/* NOTICE BOARD */}
        {notices.length > 0 && (
          <div className='notice-board'>
            <h1 className='mt-4 fs-20 fw-6'>Notice Board</h1>
            <Row className='mb-3'>
              <Col xs='12'>
                <div className='border-black border p-4 rounded'>
                  <p dangerouslySetInnerHTML={{ __html: notices[0].notice_text }} />
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Container >
    </div >
  );
}

export default Dashboard;
